import React from 'react';
import { BalanceDominosTable } from 'components/table/balance_dominos/Table';

export const BalanceDomino = () => {
    return (
        <>
        <BalanceDominosTable />
        </>
    );
}